<template>
  <div>
    <van-cell
      title-class="van-cell__title_left"
      title="订单号:"
      :value=payInfo.cardNo
    ></van-cell>
    <van-cell
      title-class="van-cell__title_left"
      title="订单名称:"
      value="门诊缴费"
    ></van-cell>
    <van-cell
      title-class="van-cell__title_left"
      title="应付金额:"
      :value=payInfo.totCost
    ></van-cell>
    <van-cell
      title-class="van-cell__title_left"
      title="还需支付:"
      :value=payInfo.totCost
      value-class="money"
    >
    </van-cell>
    <van-radio-group v-model="radioPayType">
    <van-cell title="医保支付:" title-class="van-cell__title_left">
        <img src="../../assets/medical-logo.png" slot="icon" style="width:55px;height:12px; margin-top:7px;margin-right:10px"></img>

      <template #right-icon>
        <van-radio name="gl"/>
      </template>
    </van-cell>

    <van-cell
      title="微信支付:"
      title-class="van-cell__title_left"
    >
    <img src="../../assets/wechat-logo.jpeg" slot="icon" style="width:20px;height:20px; margin-top:2px;margin-right:45px"></img>
      <template #right-icon>
        <van-radio name="wx"/>
      </template>
    </van-cell>
  </van-radio-group>
    <div style="margin: 16px;" id="divBtn">
      <van-button
        round
        block
        type="primary"
        native-type="submit"
        @click.native="goAuth"
        color="#0D7CFF"
      >
        确认支付
      </van-button>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { Form, Field, CellGroup, Button, Dialog } from "vant";
import requests from "../../api/requests.js";

export default {
  components: { CellGroup },

  data() {
    return {
      //支付页面传入信息
      payInfo: {},
      radioPayType: "gl",
      wecityUrl: "",
    };
  },
  created() {
    this.createWecityUrl();
    let that = this;
    //扫描调整过来的，需求请求拿到openid，token，还有payInfo相关数据
    let state = this.$route.query.state;
    let code = this.$route.query.code;

    if (state && state != "" && state != null) {
      let openid = localStorage.getItem(this.GLOBAL.hosUrl);
      let token = localStorage.getItem("token");
      let params = state.split(",");
      let cardNo = "";
      let totCost = "";
      if (params && params.length > 1) {
        cardNo = params[0];
        totCost = params[1];
      }

      if (openid && openid != "" && openid != null) {
        this.scanQuery(cardNo, totCost, openid);
      } else {
        let httpURL = "/wx/wxauth?code=" + code;
        requests.get(httpURL).then(function (res) {
          if (res.data != null && res.data.openid != null) {
            that.openid = res.data.openid;
            localStorage.setItem(that.GLOBAL.hosUrl, res.data.openid);
            localStorage.setItem("token", res.data.access_token);
            that.scanQuery(cardNo, totCost, openid);
          } else {
            console.log(res);
          }
        });
      }
    } else {
      this.payInfo = JSON.parse(localStorage.getItem("order")).item;
    }
  },
  methods: {
    //医保免密url生成
    createWecityUrl() {
      let that = this;
      let httpURL = "/wx/createWecityUrl";
      requests.get(httpURL).then(function (res) {
        if (res.data != null && res.data != null) {
          // console.log(res.data);
          that.wecityUrl = res.data;
        } else {
          console.log(res);
        }
      });
    },
    //扫描出来的
    scanQuery(cardNo, totCost, openid) {
      let that = this;
      let httpURL =
        "/his/scanQuery?openId=" +
        openid +
        "&cardNo=" +
        cardNo +
        "&totCost=" +
        totCost;
      requests.get(httpURL).then(function (res) {
        if (res.data != null && res.data != null) {
          let regData = { item: res.data.reg };
          localStorage.setItem("order", regData);
          that.payInfo = res.data.reg;
        } else {
          console.log(res);
        }
      });
    },
    goAuth() {
      if (this.radioPayType == "gl") {
        if (!this.payInfo.self) {
          Dialog.alert({
            title: "提示",
            message: "非本人不能用医保支付",
          });
        } else {
          // console.info(this.wecityUrl);
          window.location.href = this.wecityUrl;

          // "https://mitest.wecity.qq.com/oauth/code?authType=2&isDepart=2&appid=wx2ce38300e9cedba4&cityCode=530600&channel=AAHTsc6lGr_Jxaw5xJ88dvxn&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxuncyliggt9VVj4nl0nlRGC&orgCodg=H53062700104&bizType=04107&orgAppId=1GGP9DCSG0UO3F60C80A00002CF4BCEF&redirectUrl=https://zxskyk.dmsbrowser.com/orderDetail";
          // "https://mitest.wecity.qq.com/oauth/code?authType=2&isDepart=2&appid=wxd8221522672f1da4&cityCode=532300&channel=AAGDjhBtPzo4LJTh9gCenRkB&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxvzYTFrSLksaAaJ4Ug9kPfB&orgCodg=H53230100179&bizType=04107&orgAppId=1GK57GSSI1HS3F60C80A0000E024AF7E&redirectUrl=https://cxgkyy.glhis.com/orderDetail";

          // this.$router.push({ path: "/orderDetail", query: { ptype: "gl" } });
        }
      } else {
        this.$router.push({ path: "/orderDetail", query: { ptype: "wx" } });
      }
    },
  },
};
</script>
<style scoped>
.money {
  font-weight: bold;
  color: coral;
}
.c1 {
  width: 0.625rem;
  height: 0.625rem;
}

.mine_headicon {
  width: 150rpx;
  height: 150rpx;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
  color: #12c014;
}

.search-icon.dis {
  font-size: 16px;
  line-height: inherit;
  color: #e0dee1;
}

.div-btn {
  pointer-events: none;
  color:darkgray;
}

.van-cell__title_left {
  min-width: 50%;
  text-align: left;
}
.van-cell__value {
  min-width: 50%;
  span {
    display: inline-block;
    text-align: left;
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payFee/index.vue